import { Site } from 'shared/hooks';
import { HqApiService } from 'hq/services/hqApiService';
import { OgpApiService } from 'ogp/services/ogp-api-service';
import { FlexPool } from 'hq/services/flex-pool-service.types';
import { flexPoolsSchema } from './schema/flex-pool.schema';
import { FlexPoolResponseOgp } from './flex-pool.service.types';

export class FlexPoolService {
  constructor(
    private readonly ogpApiService: OgpApiService,
    private readonly hqApiService: HqApiService
  ) {}

  public async getFlexPoolsForFlexWorker(site: Site, flexWorkerId: string) {
    const response = await this.getFlexPoolsForFlexWorkerImpl(site, flexWorkerId);
    return flexPoolsSchema.parse(response);
  }

  public async getFlexPoolsForFlexWorkerImpl(site: Site, flexWorkerId: string) {
    const path = `flex-pools/for-flexworker/${flexWorkerId}`;
    if (site === 'hq') {
      return await this.hqApiService.get<FlexPool[]>({
        path,
      });
    } else if (site === 'ogp') {
      return await this.ogpApiService.get<FlexPool[]>({
        path,
      });
    }

    throw new Error('Not yet implemented');
  }

  public async getFlexpoolsForCompany(site: Site, companyId?: string) {
    if (site === 'hq') {
      return await this.hqApiService.get<FlexPoolResponseOgp>({
        path: `flex-pools`,
        params: { companyId },
      });
    } else if (site === 'ogp') {
      return await this.ogpApiService.get<FlexPoolResponseOgp>({
        path: `flex-pools`,
      });
    }

    throw new Error('Not yet implemented');
  }
}
